/* eslint-disable no-unused-vars */
import React, { forwardRef, Fragment, useEffect, useImperativeHandle, useState } from 'react'
import { FaChevronDown } from 'react-icons/fa'
import { cn } from 'src/lib/utils'
import { useSettingsStore } from '../Store/Store'
import ConfigurationView from './ConfigurationView'
import SaveCancelButton from 'src/Common/ui/SaveCancelButton'
import { CONFIGURATION_MENU } from 'src/Entities/ConfigurationEntity'
import { Button } from 'src/Common/ui/button'
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger
} from '../../../Common/ui/accordion'
import { IoChevronDown, IoChevronForward } from 'react-icons/io5'
import OneTimeModal from './OneTimeModal'
import { useForm } from 'react-hook-form'
const ConfigurationContainer = ({ isInitial }, ref) => {
    const [endMonth, setEndMonth] = useState(0)

    const { configurationData, SetConfigurationBasedOrganization, getConfigurationBasedOrganization } = useSettingsStore()
    const orgId = localStorage.getItem('orgId')
    const loginId = localStorage.getItem('userId')
    const [selectedTab, setSelectedTab] = useState(0)
    const [temporaryConfigurationData, setTemporaryConfigurationData] = useState([])
    useEffect(() => {
        if (configurationData?.length > 0) {
            setTemporaryConfigurationData(configurationData)
        }
    }, [configurationData])
    const [activeAccordion, setActiveAccordion] = useState(`accorrd-${temporaryConfigurationData?.length - 1}`)

    useEffect(() => {
        const find = temporaryConfigurationData?.find((item) => item.configurationTitleId === 12)?.values
        if (temporaryConfigurationData?.length > 0 && !find) {
            handleSelect(5, 12)
        }
    }, [temporaryConfigurationData])
    const handleSelectedTab = kindId => {
        if (kindId === selectedTab) {
            // setSelectedTab('')
            setSelectedTab(0)
        } else {
            setSelectedTab(kindId)
        }
    }

    const onValueChange = (elementId, value) => {
        const modifiedData = temporaryConfigurationData.map((item) => {
            if (item.configurationTitleId === elementId) {
                return { ...item, values: value, status: 28 }
            } else return { ...item, status: 28 }
        })
        setTemporaryConfigurationData(modifiedData)
    }

    const handleClose = () => {
        setTemporaryConfigurationData(configurationData)
    }
    const handleSave = async () => {
        const data = temporaryConfigurationData.map(ele => {
            ele.status = 28
            return ele
        })
        await SetConfigurationBasedOrganization(orgId, loginId, data)
        getConfigurationBasedOrganization(orgId)
    }

    const handleSelect = (value, id) => {
        console.log(value, id)
        let modifiedData = []
        modifiedData = temporaryConfigurationData.map((item) => {
            if (item.configurationTitleId === id) {
                return { ...item, values: value, status: 28 }
            } else return { ...item, status: 28 }
        })
        if (id === 11) {
            const date = new Date()
            date.setMonth(value - 1)
            date.setMonth(11 + date.getMonth())
            const endMonth = date.getMonth() + 1
            setEndMonth(endMonth)
            modifiedData = modifiedData.map((item) => {
                if (item.configurationTitleId === 12) {
                    return { ...item, values: endMonth, status: 28 }
                } else return { ...item, status: 28 }
            })
        }
        setTemporaryConfigurationData(modifiedData)
    }
    useImperativeHandle(ref, () => {
        return {
            handleSav: () => {
                handleSave()
            }
        }
    }, [temporaryConfigurationData])
    const [open, setOpen] = useState(false)

    const mockData = [
        { id: 1, regulation: 'GDPR', complianceTitle: 'Data Privacy', category: 'Legal' },
        { id: 2, regulation: 'ISO 27001', complianceTitle: 'Security Management', category: 'IT' },
        { id: 3, regulation: 'SOX', complianceTitle: 'Financial Controls', category: 'Finance' }
    ]
    const { control, reset, formState: { errors } } = useForm()

    return (
        <div className='h-[100%]' style={{ borderColor: 'hsl(var(--primary-foreground))' }}>
            <div className='h-[90%] pt-3 flex flex-col gap-3'>
                {!isInitial && <><p className="text-h0 px-4 pt-[0px] pb-2 flex flex-col justify-center items-center" style={{ fontSize: isInitial && '16px', color: isInitial ? 'hsl(var(--muted))' : 'hsl(var(--primary))' }}>{'Configuration'}</p>
                    <div className="grid  overflow-auto grid-cols-1 gap-4 px-4">
                        {CONFIGURATION_MENU.map((item, index) => (
                            <div key={`${index}-${item.kindId}`} className='border-2 flex flex-col justify-center border-primary-foreground rounded-[8px] cursor-pointer mb-[20px] w-full p-[20px]'>
                                <div onClick={() => handleSelectedTab(item.kindId)} className='flex flex-row justify-between items-center'>
                                    <p className={cn('!text-primary text-h4-selected')}>{item.kindName}</p>
                                    {selectedTab === item.kindId && <div className="flex-grow border border-primary-foreground mx-2" />}
                                    <FaChevronDown color='hsl(var(--primary))' />
                                </div>
                                {selectedTab === item.kindId &&
                                    <>
                                        <ConfigurationView
                                            endMonth={endMonth}
                                            handleSelect={handleSelect}
                                            isInitial={isInitial}
                                            selectedKindId={item.kindId}
                                            onValueChange={onValueChange}
                                            data={temporaryConfigurationData?.filter(element => element.kindId === item.kindId)}
                                            setTemporaryConfigurationData={setTemporaryConfigurationData}
                                            temporaryConfigurationData={temporaryConfigurationData}
                                        />
                                    </>
                                }
                            </div>
                        ))}
                        <div className='border-2 flex flex-col justify-center border-primary-foreground rounded-[8px] cursor-pointer mb-[20px] w-full p-[20px]'>
                            <div onClick={() => setOpen(true)} className='flex flex-row justify-between items-center'>
                                <p className={cn('!text-primary text-h4-selected')}>One-Time Compliance</p>
                                <FaChevronDown color='hsl(var(--primary))' />
                            </div>
                        </div>
                    </div> </>}
                {
                    isInitial && <div className="grid  overflow-auto grid-cols-1 gap-4 px-4">
                        <Accordion type="single" collapsible value={activeAccordion} onValueChange={(e) => setActiveAccordion(e)}>
                            {CONFIGURATION_MENU.map((item, index) => (
                                <div key={`${index}-${item.kindId}`} className='py-[5px]'>

                                    <AccordionItem className='mt-2' key={`accorrd-${index}`} value={`accorrd-${index}`}>
                                        <AccordionTrigger
                                            className='py-2 px-2'
                                            hideIcon
                                            headerClassName='onboard-accordion-header-container pr-2 hover-container'
                                            headerChild={<Fragment>
                                            </Fragment>}
                                        >
                                            <div className='flex'>
                                                <div className='my-auto mr-2'>
                                                    {activeAccordion === `accorrd-${index}`
                                                        ? <IoChevronDown className='onboard-accordion-chevron' />
                                                        : <IoChevronForward className='onboard-accordion-chevron' />}
                                                </div>
                                                <p className={cn('!text-primary text-h4-selected')}>{item.kindName}</p>
                                            </div>
                                        </AccordionTrigger>
                                        <AccordionContent>
                                            <div className='p-4'>

                                                <ConfigurationView
                                                    endMonth={endMonth}
                                                    handleSelect={handleSelect}
                                                    isInitial={isInitial}
                                                    selectedKindId={item.kindId}
                                                    onValueChange={onValueChange}
                                                    data={temporaryConfigurationData?.filter(element => element.kindId === item.kindId)}
                                                    setTemporaryConfigurationData={setTemporaryConfigurationData}
                                                    temporaryConfigurationData={temporaryConfigurationData}
                                                />
                                            </div>
                                        </AccordionContent>
                                    </AccordionItem>

                                    {/* <div onClick={() => handleSelectedTab(item.kindId)} className='flex flex-row justify-between items-center'>
                                    <p className={cn('!text-primary text-h4-selected')}>{item.kindName}</p>
                                    { selectedTab === item.kindId && <div className="flex-grow border border-primary-foreground mx-2" /> }
                                    <FaChevronDown color='hsl(var(--primary))' />
                                </div> */}
                                    {/* {selectedTab === item.kindId &&
                                <>
                                    <ConfigurationView
                                        endMonth={endMonth}
                                        handleSelect={handleSelect}
                                        isInitial={isInitial}
                                        selectedKindId={item.kindId}
                                        onValueChange={onValueChange}
                                        data={temporaryConfigurationData?.filter(element => element.kindId === item.kindId)}
                                        setTemporaryConfigurationData={setTemporaryConfigurationData}
                                        temporaryConfigurationData={temporaryConfigurationData}
                                    />
                                </>
                                } */}
                                </div>
                            ))}
                        </Accordion>
                        <div onClick={() => setOpen(true)} className="flex items-center cursor-pointer  gap-2 bg-[#e9f5f5] text-teal-700 py-2 px-3 rounded-md">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="w-4 h-4"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                strokeWidth="2"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                            </svg>
                            <div className="!text-primary text-h4-selected">

                                One-Time Compliance

                            </div>
                        </div>
                    </div>
                }

            </div>
            {selectedTab !== '' && <div className="h-[4%] flex flex-row justify-end space-x-4 py-7 pr-8 items-center" >
                {!isInitial && <SaveCancelButton style={{ color: 'white', position: 'fixed', justifyContent: 'end', bottom: 0 }} handleCancel={handleClose} handleSave={handleSave} />}
            </div>}
            <OneTimeModal isOpen={open} onClose={() => setOpen(false)} data={mockData} control={control} reset={reset} errors={errors} />

        </div>
    )
}
export const ConfigurationsContainer = forwardRef(ConfigurationContainer)
